const CONFIGURED_BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
const BACKEND_URL = process.env.NODE_ENV === "production" ? "" : CONFIGURED_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const request = async (path, token, options = {}) => {
  const controller = new AbortController();
  const timeout = window.setTimeout(() => controller.abort(), 12000);
  try {
    const response = await fetch(`${API}${path}`, {
      credentials: "include",
      headers: {
        ...(options.body ? { "Content-Type": "application/json" } : {}),
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        ...(options.headers || {}),
      },
      ...options,
      signal: controller.signal,
    });

    if (!response.ok) {
      const body = await response.json().catch(() => ({}));
      const detail = typeof body.detail === "string" ? body.detail : body.detail?.message;
      const error = new Error(detail || `Request failed: ${response.status}`);
      error.status = response.status;
      throw error;
    }
    return response.json();
  } catch (error) {
    if (error?.name === "AbortError") {
      const timeoutError = new Error("Aktionsstatus konnte nicht rechtzeitig geprüft werden.");
      timeoutError.status = 408;
      throw timeoutError;
    }
    throw error;
  } finally {
    window.clearTimeout(timeout);
  }
};

export const listPendingActionReconciliations = async (token, limit = 20) =>
  request(`/service-connect/reconciliation/actions?limit=${encodeURIComponent(limit)}`, token);

export const listActionRecords = async (token, limit = 50) =>
  request(`/intelligence/actions?limit=${encodeURIComponent(limit)}`, token);

export const reconcileUnknownAction = async (actionId, token) =>
  request(`/service-connect/reconciliation/actions/${encodeURIComponent(actionId)}`, token, { method: "POST" });
